import script from "./AlertDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertDialog.vue?vue&type=script&setup=true&lang=js"

import "./AlertDialog.vue?vue&type=style&index=0&id=db3c59f4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db3c59f4"]])

export default __exports__